export default {
  toPay: '/income/client/activity/buyCard'
}
